<!--
*    1. title -> 单選 group的title
*    2. filterData -> 顯示的checkbox有哪些，格式為[{name: String, val: String},{name: String, val: String},...]
*    3. v-model回傳選擇的val

-->

<template>
  <div class="c8-select">
    <div class="c8-select__title">
      <span class="c8-select__text">{{ title }}：</span>
    </div>
    <div class="c8-select__content">
      <a
        v-for="(item, index) in filterData"
        :key="`${item.name}_${index}`"
        class="button-outline c8-select__content__item"
        :class="{ active: value === item.val }"
        @click.prevent="handleClick(item.val)"
      >
        <span class="button-outline__text">{{ item.name }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleSelectGroup',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      reruire: false,
      default: () => ''
    },
    filterData: {
      type: Array,
      require: true,
      default: () => []
    },
    value: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      selectList: this.filterData
    }
  },

  methods: {
    handleClick(item) {
      this.$emit('change', item)
    }
  }
}
</script>
